import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let TableComp;

class Table extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: TableComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/zcat-components/table-comp" */
      "../../../components/javascript/zcat-components/table-comp").then(function(res) {
        TableComp = res.TableComp;
      })
    );

    
;
  }
}

export { Table };
